export enum ToggleEnum {
  ACCOUNTS_WITH_STATES = "ACCOUNTS_WITH_STATES",
  ADL_TEAM_CLIENT_VALIDATION = "ADL_TEAM_CLIENT_VALIDATION",
  BANKING_INSURANCE = "BANKING_INSURANCE",
  CERTIHUELLA_PHONE_FUNCTION = "CERTIHUELLA_PHONE_FUNCTION",
  DECRIM_PHONE_FUNCTION = "DECRIM_PHONE_FUNCTION",
  FEDERATED_AUTHENTICATION = "FEDERATED_AUTHENTICATION",
  LOYALTY_SAME_FEE = "LOYALTY_SAME_FEE",
  NEW_CLIENT_ACCESS = "NEW_CLIENT_ACCESS",
  NEW_CLIENT_EDUCATIONAL_SECTOR_TOGGLE = "NEW_CLIENT_EDUCATIONAL_SECTOR_TOGGLE",
  ONBASE_LOAD_DOCUMENT_FEATURE_TOGGLE = "ONBASE_LOAD_DOCUMENT_FEATURE_TOGGLE",
  ORGANIZATION_LAMBDAS_FEATURE_TOGGLE = "ORGANIZATION_LAMBDAS_FEATURE_TOGGLE",
  PAYROLL_CHECK_OPTIMIZATION_II = "PAYROLL_CHECK_OPTIMIZATION_II",
  PREVALIDATION_SIMULATION = "PREVALIDATION_SIMULATION",
  RECAPTCHA = "RECAPTCHA",
  REQUEST_WORK_CERTIFICATE_EDUCATIONAL_SECTOR = "REQUEST_WORK_CERTIFICATE_EDUCATIONAL_SECTOR",
  SIM_VALIDATION = "SIM_VALIDATION",
  TELEPHONIC_MODEL = "TELEPHONIC_MODEL",
  TWILIO_SMS_AND_CALL = "TWILIO_SMS_AND_CALL",
  UPLOAD_FACIAL_IDENTIFICATION_DECRIM_TOGGLE = "UPLOAD_FACIAL_IDENTIFICATION_DECRIM_TOGGLE",
  USE_FOOTPRINTS_NEW_SERVICE_TOGGLE = "USE_FOOTPRINTS_NEW_SERVICE_TOGGLE",
  USE_INTERNAL_BANK_ODM = "USE_INTERNAL_BANK_ODM",
  USE_NEW_GROWTH_POLICY = "USE_NEW_GROWTH_POLICY",
  USE_NEW_SIMULATION_SERVICE = "USE_NEW_SIMULATION_SERVICE",
  USE_NEW_SIMULATION_SERVICE_SAME_FEE = "USE_NEW_SIMULATION_SERVICE_SAME_FEE",
}
